import { withManifest } from '@godaddy/gasket-hcs';

// css for a11y skip to main component
import '@godaddy/gasket-hcs/dist/styles.css';

import '@ux/account-delegation/styles';
import '@ux/browser-deprecation-banner/styles';

/**
 * React Component to render the Header.
 * This component must be present, but may return null if no header is required.
 *
 * @param {Object} props The props for this component
 * @returns {React.ReactElement} JSX for header
 */
// eslint-disable-next-line no-unused-vars
export function Header(props) {
  return null;
}

/**
 * Export Header with Manifest HOC.
 *
 * `no-header` does not support navigation nor help UI, but we expose these
 * methods to provide compatibility when swapping in `no-header` for other
 * headers like `application-header`
 *
 * @component
 * @public
 */
export default withManifest(Header, {
  renderAccountDelegation: true,
  initCustomerState: true,
  initTraffic: true,
  additionalHeaderMethods: {
    updateHelpUrl: () => {},
    updateNavigation: () => {},
    updateTopNavigation: () => {}
  }
});
